import React from 'react';
export function OpeningHours() {
  return (
    <svg viewBox="0 0 22 22" width="22px" height="22px">
      <g transform="translate(-1 -1)">
        <circle cx={12} cy={12} r={10} fill="none" stroke="#0096aa" />
        <path
          fill="none"
          stroke="#0096aa"
          strokeLinecap="square"
          d="M12 7v5l2.3 2.2"
        />
      </g>
    </svg>
  );
}
